import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"
  title: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
  },
  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 24,
  },
  subTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    // marginBottom: '8% !important' (this one is when the icon location is inside the pdf)
  },

  // This location was when the pin was inside the pdf but they ask me to change it
  // in the jsx it was inside pdfContainer but I pull it out 
  // locationIcon: {
  //   width: '40px !important',
  //   height: '40px !important',
  //   position: 'absolute !important',
  //   right: '60px !important',
  //   marginTop: '5px !important',
  //   zIndex: '1',
  //   backgroundColor: '#F37F00',
  //   borderRadius: '30px',
  //   textAlign: 'center',
  //   ['@media only screen and (max-width: 812px)']: {
  //     right: '10px !important',
  //   },
  // },

  iconposition: {
    width: '100% !important',
    display: 'flex',
    justifyContent: 'flex-end'
  },

  locationIcon: {
    width: '40px !important',
    height: '40px !important',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '100%',
    textAlign: 'center',
    marginBottom: '5px !important',
    marginRight: theme.spacing(1)
  },

  iconLoc: {
    backgroundColor: '#D23D59', //theme.palette.primary.main,
    color: '#FFFFFF',
    // marginTop: '10px',
    height: '35px',
    width: '35px',
    borderRadius: '100%',
    marginLeft: '8px',
    marginTop: '3px',
    padding: '6px',
    // zIndex: '200',
  },
  policyContainer: {
    position: 'parent !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
  },
  mapContainer: {
    height: '70vh !important',
    width: '100% !important',
    backgroundColor: '#8F918F',
  },
  btnContainer: {
    display: 'flex !important',
    flexDirection: 'row !important',
    alignItems: 'flex-end !important',
    justifyContent: 'flex-end !important',
    width: '100% !important',
    //outline: 'solid 1px tomato !important',
  },
  mapTitle: {
    fontWeight: 'bold',
    fontSize: 20,
    width: '90% !important',
    textAlign: 'left !important',
    ['@media only screen and (max-width: 812px)']: {
      fontSize: 18,
      marginTop: '5%'
    },
    //outline: 'solid 1px tomato !important',
  },
  acceptBtn: {
    //margin: theme.spacing(1),
    width: '100%',
    // margin: '8px !important',
  },
  pdfContainer: {
    // marginTop: theme.spacing(2), 
    display: 'flex !important',
    flexDirection: 'column !important',
    width: '100% !important',
    height: '65vh !important',
    backgroundColor: '#8F918F',
    overflowY: 'none',
    scrollBehaviour: 'smooth',
    marginBottom: '1.4% !important',
    ['@media only screen and (max-width: 812px)']: {
      width: '100% !important',
      height: '60vh !important',
      backgroundColor: '#8F918F',
      overflowY: 'auto',
      scrollBehaviour: 'smooth',
      marginBottom: '14% !important'
    },
  },
  checksContainer: {
    //height: '60vh',
    overflowY: 'auto',
    display: 'flex !important',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'left !important',
    width: '95% !important',
    margin: '14px !important'
    //outline: 'solid 1px tomato !important',
  },
  controlLabel: {
    width: '100% !important',
    paddingLeft: "0.8em !important",
    ['@media only screen and (max-width: 812px)']: {
      width: '90% !important',
      marginLeft: '5%'
    },
    //outline: 'solid 1px tomato !important',
  },
  checkboxText: {
    fontWeight: 'bold',
    fontSize: "1em",

    //outline: 'solid 1px tomato !important',
  },
  buttonsTitle: {
    width: '100% !important',
    textAlign: 'left !important',
    paddingLeft: theme.spacing(1),
    fontSize: 14,
    ['@media only screen and (max-width: 812px)']: {
      fontSize: 14,
    },
    //outline: 'solid 1px tomato !important',
  },
  authButton: {
    marginTop: theme.spacing(3),
    position: 'absolute !important',
    width: '100% !important',
    // left: '32.5% !important',
    // ['@media only screen and (max-width: 800px)']: {
    //   // width: '90% !important',
    //   left: '5% !important',
    // },
    bottom: '0px !important',
    // height: '40px',
    backgroundColor: theme.palette.primary.main,
    //outline: 'solid 1px tomato !important',
    borderTopRightRadius: '10px',
    borderTopLeftRadius: '10px',
  },
  centerContent1: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: '60%',
    height: '92vh',
    position: 'relative',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
      height: '90vh',
    }
  },
  space: {
    height: '50px',
    ['@media only screen and (max-width: 812px)']: {
      height: '10px',
    },
  },
  sheetHeader: {
    top: '0',
    left: '0',
    width: '100% !important',
    backgroundColor: theme.palette.primary.main,
    //outline: 'solid 1px tomato !important',
    borderTopRightRadius: '10px',
    borderTopLeftRadius: '10px',
    display: 'flex',
  },
  ButtonEnabled: {
    // marginTop: theme.spacing(3),
    margin: theme.spacing(0.5),
    marginBottom: '15px !important'
  },
  ButtonDisabled: {
    // marginTop: theme.spacing(3),
    margin: theme.spacing(0.5),
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important',
    marginBottom: '15px !important'
  },
  fieldSetCustom: {
    overflowY: 'auto !important',
    marginTop: '1em !important',
  },
  customBottomSheet: {
    padding: '0 !important',
    height: '50px !important',
    zIndex: '7 !important',
    "&[data-rsbs-is-dismissable='false'] [data-rsbs-backdrop]": {
      zIndex: '7 !important',
    },
    "&[data-rsbs-is-dismissable='false'] [data-rsbs-overlay]": {
      zIndex: '10 !important',
      width: '35% !important',
      marginLeft: '32.5% !important',
      ['@media only screen and (max-width: 812px)']: {
        width: '100% !important',
        marginLeft: '0 !important'
      },
    },
    "&[data-rsbs-is-dismissable='false'] [data-rsbs-overlay]::after": {
      zIndex: '10 !important',
      width: '35% !important',
      marginLeft: '32.5% !important',
      ['@media only screen and (max-width: 812px)']: {
        width: '100% !important',
        marginLeft: '0 !important'
      },
    }
  },
  closeButton: {
    color: `${theme.palette.primary.color} !important`,
    '&&:focus': {
      outline: 'none'
    }
  },
  backButton: {
    color: '#FFFFFF !important',
    '&&:focus': {
      outline: 'none'
    }
  },
  borderless: {
    outline: 'none !important'
  },
  fclClassName: {
    marginRight: '0px !important'
  },
  checksList: {
    // width: '100% !important',
    // marginTop: '2% !important',
    // marginTop: '0px !important',
    opacity: 1,
    borderRadius: 6,
    backgroundColor: '#fff',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // paddingTop: '5px !important',
    // paddingTop: '0px !important',
    // paddingBottom: '5px !important',
    // marginTop: '10px !important',
    // marginBottom: '7px !important',
  },
  containerResult: {
    display: 'grid !important',
    gridTemplateColumns: '90% 10%',
    // height: '55vh !important',
    marginTop: 5,
    marginBottom: 5,
    width: '100%',
    // backgroundColor: theme.palette.background.paper,
    overflowY: 'none',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '93% 7%',
      overflowY: 'none',
      // height: '55vh !important',
    },
    // marginBottom: '5% !important'
  },
  leftColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'flex-start !important',
    overflowY: 'none',
    justifyContent: 'flex-start !important',
  },
  rightColumnResult: {
    display: 'flex',
    flexDirection: 'column !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    overflowY: 'none',
  },
  centerContentPdfMovil: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    // height: '67vh',
    position: 'relative',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
      height: '60vh',
    }
  },

  visorContentPrinc: {
    border: '1px solid #A0A1A2',
    position: 'relative',
    overflow: 'hidden',
    textAlign: 'center',
    height: '100%',
    width: '100%',
  },
  pdfContentCenter: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    textAlign: 'center',
  },
  wid100: {
    width: '100% !important'
  },
}))
